module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_8017.3440e1dd.png";